import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M30 4a1 1 0 0 0-1-1H18a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1zM2 20a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-2.447a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1zM2 11a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v2.667a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zM15 4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v2.667a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1z"
    }, null, -1)
  ])))
}
export default { render: render }